import { axiosInstance } from "@/plugins/axios";

export default {
  namespaced: true,
  state: {
    positions: [],
    departments: [],
    leadsStatus: [],
    leads: [],
  },
  getters: {
    positions(state) {
      return state.positions;
    },
    departments(state) {
      return state.departments;
    },
    leadsStatus(state) {
      return state.leadsStatus;
    },
    leads(state) {
      return state.leads;
    },
  },
  mutations: {
    SET_POSITIONS(state, value) {
      state.positions = value;
    },
    SET_DEPARTMENTS(state, value) {
      state.departments = value;
    },
    SET_LEADS_STATUS(state, value) {
      state.leadsStatus = value;
    },
    SET_LEADS(state, value) {
      state.leads = value;
    },
  },
  actions: {
    async registerPositions(context, value) {
      const url = value?.id
        ? `company/positions/${value.id}`
        : "company/positions";

      await axiosInstance({
        method: "POST",
        url: url,
        data: value,
      })
        .then((response) => response.data)
        .then(() => {
          context.dispatch("consultPositions");
        });
    },
    async consultPositions(context, value) {
      const url = value?.id
        ? `company/positions/${value.id}`
        : "company/positions";

      const { data } = await axiosInstance({
        method: "GET",
        url: url,
      });

      context.dispatch("setDataDefault", ["SET_POSITIONS", data]);
    },
    async removePosition(context, id) {
      await axiosInstance({
        method: "DELETE",
        url: `company/positions/${id}`,
      });

      context.dispatch("consultPositions");
    },
    async registerDepartments(context, value) {
      const url = value?.id
        ? `company/departments/${value.id}`
        : "company/departments";

      await axiosInstance({
        method: "POST",
        url: url,
        data: value,
      })
        .then((response) => response.data)
        .then(() => {
          context.dispatch("consultDepartments");
        });
    },
    async consultDepartments(context, value) {
      const url = value?.id
        ? `company/departments/${value.id}`
        : "company/departments";

      const { data } = await axiosInstance({
        method: "GET",
        url: url,
      });

      context.dispatch("setDataDefault", ["SET_DEPARTMENTS", data]);
    },
    async removeDepartment(context, id) {
      await axiosInstance({
        method: "DELETE",
        url: `company/departments/${id}`,
      });

      context.dispatch("consultDepartments");
    },
    async registerLeadsStatus(context, value) {
      const url = value?.id
        ? `company/leadsStatus/${value.id}`
        : "company/leadsStatus";

      await axiosInstance({
        method: "POST",
        url: url,
        data: value,
      })
        .then((response) => response.data)
        .then(() => {
          context.dispatch("consultLeadsStatus");
        });
    },
    async consultLeadsStatus(context, value) {
      const url = value?.id
        ? `company/leadsStatus/${value.id}`
        : "company/leadsStatus";

      const { data } = await axiosInstance({
        method: "GET",
        url: url,
      });

      context.dispatch("setDataDefault", ["SET_LEADS_STATUS", data]);
    },
    async removeLeadStatus(context, id) {
      await axiosInstance({
        method: "DELETE",
        url: `company/leadsStatus/${id}`,
      });

      context.dispatch("consultLeadsStatus");
    },
    async saveLeads(context, value) {
      const url = value?.id ? `company/leads/${value.id}` : "company/leads";

      await axiosInstance({
        method: "POST",
        url: url,
        data: value,
      })
        .then((response) => response.data)
        .then(() => {
          context.dispatch("consultLeads");
        });
    },
    async consultLeads(context, value) {
      const url = value?.id ? `company/leads/${value.id}` : "company/leads";

      const { data } = await axiosInstance({
        method: "GET",
        url: url,
      });

      context.dispatch("setDataDefault", ["SET_LEADS", data]);
    },
    setDataDefault(context, [mutationName, value]) {
      context.commit(`${mutationName}`, value);
    },
  },
};
